import {AppState} from '../Root.store'

export const selectJobHistory = (state: AppState) => state.asyncjobqueue.jobHistory
export const selectReportedJobs = (state: AppState) => state.asyncjobqueue.reportedJobs
